<template>
    <NuxtLink to="/contact">
        <div v-if="visible"
            class="w-full p-4 bg-slate-700 tracking-wide text-white text-center text-sm relative hover:bg-slate-800 hover:cursor-pointer">
            <span>{{ message }}</span>

            <button @click="closeBanner" class="absolute right-4 top-2 text-white text-xl">&times;</button>
        </div>
    </NuxtLink>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
    message: {
        type: String,
        default: 'This is a banner message!',
    },
});

const visible = ref(true);

const closeBanner = () => {
    visible.value = false;
};
</script>

<style scoped>
/* Add any additional styling here if needed */
</style>